import { useSuspenseQuery } from '@tanstack/react-query';
import { startupQueries } from 'app/agriculture/contexts/RequiredStartupProviders/queries';

export function useCurrentUser() {
    const {
        data: { id, name },
    } = useSuspenseQuery(startupQueries.token);
    return { id, name } as const;
}
